import { NewLicenseFormData } from '@/interfaces/license.interface';
import type { Product } from "@/interfaces/product.interface";

// Generate unique UUID
export const generateUniqueUID = () => {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
};

export const defaultGrades = () => [
  ...Array.from({ length: 12 }, (_, index) => {
    const gradeLevel = index + 1;
    const editing: Record<string, boolean> = { maths: false, english: false };

    return {
      grade: gradeLevel.toString(),
      selected: false,
      classes: [
        {
          tempId: generateUniqueUID(),
          name: '',
          teacher: '',
          subject: '',
          gradeLevel,
          preferredLanguage: '',
          english: false,
          maths: false,
          englishTeachers: {},
          mathsTeachers: {},
        },
      ],
      editing,
    };
  }),
];

export const wondeDefaultSchoolObject = () => ({
  _id: "",
  classGroups: [] as string[],
  gradeLevels: [] as number[],
  name: "",
  description: "",
  language: "",
  domain: "",
  status: "",
  emisNumber: "",
  subjectsAvailable: [],
  schoolGroup: "",
  gradeNamingConvention: "",
  schoolLicense: "",
  academicYearStart: "",
  academicYearEnd: "",
  location: {
    city: "",
    country: "",
  },
  preferredLang: "",
  wondeId: "",
  wondeApi: "",
  settings: {
    freshchat: false,
  },
  schoolLicenseData: {
    type: "",
    startDate: "",
    endDate: "",
    status: "",
    products: [
      {
        _id: "",
        maxSeats: 0,
        name: "",
        title: "",
      },
    ],
  },
});

export const createDefaultSchoolLicenseObject = (
  schoolGroupId: string,
  products: Product[]
) => ({
  name: "",
  domain: "",
  emisNumber: "",
  schoolGroup: schoolGroupId,
  academicYearStart: "",
  academicYearEnd: "",
  preferredLang: "",
  subjectsAvailable: [],
  location: {
    city: "",
    country: "",
    street: "",
  },
  schoolLicenseData: {
    type: "annual",
    startDate: "",
    endDate: "",
    products: products.map((product) => ({
      product: product._id,
      maxSeats: 0,
      seatsUsed: 0,
    })),
  } as NewLicenseFormData,
});

export const createDefaultNewAdmin = (schoolId: string) => ({
  firstName: "",
  lastName: "",
  email: "",
  designation: "School Champion",
  status: "inactive",
  roles: [],
  phoneNumber: null,
  school: schoolId,
});

export const createDefaultSchoolObject = (
  schoolGroupId: string
) => ({
  name: "",
  domain: "",
  emisNumber: "",
  schoolGroup: schoolGroupId,
  academicYearStart: "",
  academicYearEnd: "",
  preferredLang: "",
  subjectsAvailable: [],
  location: {
    city: "",
    country: "",
    street: "",
  },
  settings: {
    freshchat: false,
  },
  excludeFromAutoArchiving: false,
});

export const defaultNewSchoolGroupAdmin = {
  firstName: "",
  lastName: "",
  email: "",
  designation: "School Group Champion",
  status: "inactive",
  roles: [],
  phoneNumber: null,
  schoolGroup: ""
};

export const defaultSchoolGroup = {
  name: "",
  description: "",
};
